// AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar si hay usuario guardado al cargar
    const currentUser = authService.getCurrentUser();
    if (currentUser) {
      setUser(currentUser);
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const result = await authService.login(email, password);

      if (result.success) {
        setUser(result.user);
        return { success: true };
      }
      return {
        success: false,
        error: result.error || 'Error desconocido en el login'
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Error inesperado en el login'
      };
    }
  };

  const register = async (userData) => {
    try {
      const result = await authService.register(userData);

      if (result.success) {
        // Después de registrar, hacemos login automático
        const loginResult = await authService.login(userData.email, userData.password);

        if (loginResult.success) {
          setUser(loginResult.user);
        }
        return {
          success: true,
          message: result.message
        };
      }
      return {
        success: false,
        error: result.error || 'Error desconocido en el registro'
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Error inesperado en el registro'
      };
    }
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  const value = {
    user,
    loading, // ¡IMPORTANTE! Exportar loading
    login,
    register,
    logout,
    isAuthenticated: authService.isAuthenticated()
  };

  return (
    <AuthContext.Provider value={value}>
      {children} {/* Quitamos el check de loading aquí */}
    </AuthContext.Provider>
  );
};